import API from "./api";
export const login = async (userDetails) => {
  const response = await API.post(`/login/`, userDetails, {
    headers: {
      "Content-Type": "application/json",
    },
  }).catch((err) => console.log(err));
  if (response.response) {
    if (response.response.status == 404) {
      console.log(response.response.data);
    }
    if (response.response.status == 401) {
      console.log(response.response.data);
    }
    return {};
  } else {
    if (response.status == 200) {
      return response ? response.data : {};
    }
  }
};

export const userDetails = async (access) => {
  const response = await API.get(`/user/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => console.log(err));
  if (response.response) {
    if (response.response.status == 401) {
      console.log(response.response.data);
    }
    return {};
  } else {
    if (response.status == 200) {
      return response ? response.data : {};
    }
  }
};

export const refresh = async () => {
  const data = {
    refresh_token: localStorage.getItem("refresh"),
  };
  const response = await API.post(`/refresh/`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  }).catch((err) => console.log(err));
  if (response.response) {
    if (response.response.status != 200) {
      console.log(response.response.data);
      localStorage.clear();
    }
    return {};
  } else {
    if (response.status == 200) {
      return response ? response.data : {};
    }
  }
};

export const signup = async (userDetails) => {
  const response = await API.post(`/signup/`, userDetails, {
    headers: {
      "Content-Type": "application/json",
    },
  }).catch((err) => console.log(err));
  if (response.response) {
    if (response.response.status == 500) {
      console.log(response.response.data);
    }
    return {};
  } else {
    if (response.status == 200) {
      return response ? response.data : {};
    }
  }
};

export const manufacturing = async () => {
  const response = await API.get(`/manufacturing/`).catch((err) =>
    console.log(err)
  );
  if (response.response) {
    if (response.response.status == 500) {
      console.log(response.response.data);
    } else if (response.response.status == 404) {
      console.log(response.response.data);
    }
    return response ? response.response.data : {};
  } else {
    if (response.status == 200) {
      return response ? response.data : {};
    }
  }
};

export const packaging = async () => {
  const response = await API.get(`/packaging/`).catch((err) =>
    console.log(err)
  );
  if (response.response) {
    if (response.response.status == 500) {
      console.log(response.response.data);
    } else if (response.response.status == 404) {
      console.log(response.response.data);
    }
    return response ? response.response.data : {};
  } else {
    if (response.status == 200) {
      return response ? response.data : {};
    }
  }
};

export const researchAndDevelopment = async () => {
  const response = await API.get(`research-and-development/`).catch((err) =>
    console.log(err)
  );
  if (response.response) {
    if (response.response.status == 500) {
      console.log(response.response.data);
    } else if (response.response.status == 404) {
      console.log(response.response.data);
    }
    return response ? response.data : {};
  } else {
    if (response.status == 200) {
      return response ? response.data : {};
    }
  }
};

export const homepage = async () => {
  const response = await API.get(`homepage/`).catch((err) => console.log(err));
  if (response.response) {
    if (response.response.status == 500) {
      console.log(response.response.data);
    } else if (response.response.status == 404) {
      console.log(response.response.data);
    }
    return response ? response.data : {};
  } else {
    if (response.status == 200) {
      return response ? response.data : {};
    }
  }
};

export const getSettingDetailsApi = async () => {
  const response = await API.get(`setting/`).catch((err) => console.log(err));
  if (response.response) {
    if (response.response.status == 500) {
      console.log(response.response.data);
    } else if (response.response.status == 404) {
      console.log(response.response.data);
    }
    return response ? response.data : {};
  } else {
    if (response.status == 200) {
      return response ? response.data : {};
    }
  }
};

export const getSocialIconsApi = async () => {
  const response = await API.get(`social-link/`).catch((err) =>
    console.log(err)
  );
  if (response.response) {
    if (response.response.status == 500) {
      console.log(response.response.data);
    } else if (response.response.status == 404) {
      console.log(response.response.data);
    }
    return response ? response.data : {};
  } else {
    if (response.status == 200) {
      return response ? response.data : {};
    }
  }
};

export const getAboutUsDetailsApi = async () => {
  const response = await API.get(`about-us/`).catch((err) => console.log(err));
  if (response.response) {
    if (response.response.status == 500) {
      console.log(response.response.data);
    } else if (response.response.status == 404) {
      console.log(response.response.data);
    }
    return response ? response.data : {};
  } else {
    if (response.status == 200) {
      return response ? response.data : {};
    }
  }
};
export const accreditation = async () => {
  const response = await API.get(`accreditation/`).catch((err) =>
    console.log(err)
  );
  if (response.response) {
    if (response.response.status == 500) {
      console.log(response.response.data);
    } else if (response.response.status == 404) {
      console.log(response.response.data);
    }
    return response ? response.data : {};
  } else {
    if (response.status == 200) {
      return response ? response.data : {};
    }
  }
};

export const otcProducts = async () => {
  const response = await API.get(`/otc-products/`).catch((err) =>
    console.log(err)
  );
  if (response.response) {
    if (response.response.status == 500) {
      console.log(response.response.data);
    } else if (response.response.status == 404) {
      console.log(response.response.data);
    }
    return response ? response.response.data : {};
  } else {
    if (response.status == 200) {
      return response ? response.data : {};
    }
  }
};

export const postSearchDataApi = async (value) => {
  const response = await API.post(`/search/`, value, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }).catch((err) => console.log(err));
  return response ? response.data : {};
};

export const getProductDetailsApi = async () => {
  const response = await API.get(`all-product-categories-item/`).catch((err) =>
    console.log(err)
  );
  if (response.response) {
    if (response.response.status == 500) {
      console.log(response.response.data);
    } else if (response.response.status == 404) {
      console.log(response.response.data);
    }
    return response ? response.data : {};
  } else {
    if (response.status == 200) {
      return response ? response.data : {};
    }
  }
};
export const events = async () => {
  const response = await API.get(`events/`).catch((err) => console.log(err));
  if (response.response) {
    if (response.response.status == 500) {
      console.log(response.response.data);
    } else if (response.response.status == 404) {
      console.log(response.response.data);
    }
    return response ? response.data : {};
  } else {
    if (response.status == 200) {
      return response ? response.data : {};
    }
  }
};
export const singleEvent = async (eventId) => {
  const response = await API.get(`singleEvent/${eventId}`).catch((err) => console.log(err));
  if (response.response) {
    if (response.response.status == 500) {
      console.log(response.response.data);
    } else if (response.response.status == 404) {
      console.log(response.response.data);
    }
    return response ? response.data : {};
  } else {
    if (response.status == 200) {
      return response ? response.data : {};
    }
  }
};
export const getBlogDetailsApi = async () => {
  const response = await API.get(`blog/`).catch((err) => console.log(err));
  if (response.response) {
    if (response.response.status == 500) {
      console.log(response.response.data);
    } else if (response.response.status == 404) {
      console.log(response.response.data);
    }
    return response ? response.data : {};
  } else {
    if (response.status == 200) {
      return response ? response.data : {};
    }
  }
};
export const getGalleryDetailsApi = async () => {
  const response = await API.get(`gallery/`).catch((err) => console.log(err));
  if (response.response) {
    if (response.response.status == 500) {
      console.log(response.response.data);
    } else if (response.response.status == 404) {
      console.log(response.response.data);
    }
    return response ? response.data : {};
  } else {
    if (response.status == 200) {
      return response ? response.data : {};
    }
  }
};
export const postCareerRequestApi = async (data) => {
  const response = await API.post(`/career_request/`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }).catch((err) => console.log(err));
  return response ? response.data : {};
};
export const getCareerPageDetailsApi = async () => {
  const response = await API.get(`career/`).catch((err) => console.log(err));
  if (response.response) {
    if (response.response.status == 500) {
      console.log(response.response.data);
    } else if (response.response.status == 404) {
      console.log(response.response.data);
    }
    return response ? response.data : {};
  } else {
    if (response.status == 200) {
      return response ? response.data : {};
    }
  }
};
export const getTexferDetailsApi = async () => {
  const response = await API.get(`texfer/`).catch((err) => console.log(err));
  if (response.response) {
    if (response.response.status == 500) {
      console.log(response.response.data);
    } else if (response.response.status == 404) {
      console.log(response.response.data);
    }
    return response ? response.data : {};
  } else {
    if (response.status == 200) {
      return response ? response.data : {};
    }
  }
};
export const postContactRequestApi = async (data) => {
  const response = await API.post(`/contact_request/`, data, {
    headers: {
      // "Content-Type": "multipart/form-data",
      "Content-Type": "application/json",
    },
  }).catch((err) => console.log(err));
  return response ? response.data : {};
};

export const getContactDetailsApi = async () => {
  const response = await API.get(`contact/`).catch((err) => console.log(err));
  if (response.response) {
    if (response.response.status == 500) {
      console.log(response.response.data);
    } else if (response.response.status == 404) {
      console.log(response.response.data);
    }
    return response ? response.data : {};
  } else {
    if (response.status == 200) {
      return response ? response.data : {};
    }
  }
};

export const certificate = async () => {
  const response = await API.get(`certificate/`).catch((err) =>
    console.log(err)
  );
  if (response.response) {
    if (response.response.status == 500) {
      console.log(response.response.data);
    } else if (response.response.status == 404) {
      console.log(response.response.data);
    }
    return response ? response.data : {};
  } else {
    if (response.status == 200) {
      return response ? response.data : {};
    }
  }
};

export const requestCallbackAPI = async (formData) => {
  // const details=JSON.stringify(formData);
  const response = await API.post(`request-callback/`, formData, {
    headers: {
      "Content-Type": "application/JSON",
    },
  });

  if (response.response) {
    if (response.response.status == 500) {
      console.log(response.response.data);
    } else if (response.response.status == 404) {
      console.log(response.response.data);
    }
    return response ? response.data : {};
  } else {
    if (response.status == 200) {
      return response ? response.data : {};
    }
  }
};

export const privacyPolicy = async () => {
  const response = await API.get(`privacy-policy/`).catch((err) =>
    console.log(err)
  );
  if (response.response) {
    if (response.response.status == 500) {
      console.log(response.response.data);
    } else if (response.response.status == 404) {
      console.log(response.response.data);
    }
    return response ? response.data : {};
  } else {
    if (response.status == 200) {
      return response ? response.data : {};
    }
  }
};

export const termsAndConditionsDetailsApi = async () => {
  const response = await API.get(`terms-and-conditions/`).catch((err) =>
    console.log(err)
  );
  if (response.response) {
    if (response.response.status == 500) {
      console.log(response.response.data);
    } else if (response.response.status == 404) {
      console.log(response.response.data);
    }
    return response ? response.data : {};
  } else {
    if (response.status == 200) {
      return response ? response.data : {};
    }
  }
};

export const getMatriMonialDetailsAPI = async (type) => {
  try {
    const response = await API.get(`matrimonial_details/`, {
      params: { type },
    });
    return response.data;
  } catch (err) {
    console.log(err);
    return {};
  }
};

export const matrimonyRequestDetailsAPI = async (matrimonyData) => {
  const response = await API.post(`matrimony_request/`, matrimonyData, {
    headers: {
      "Content-Type": "multipart/form-data",
      // "Content-Type": "application/json",
    },
  }).catch((err) => console.log(err));
  return response ? response.data : {};
};

/**
 * Added by - Ashlekh on 08-04-2025
 * Reason - API to get Member details
 */
export const getMemberDetailsAPI = async (type) => {
  try {
    const response = await API.get(`member_details/`, {
      params: { type },
    });
    return response.data;
  } catch (err) {
    console.log(err);
    return {};
  }
};

/**
 * End of code - Ashlekh on 08-04-2025
 * Reason - API to get Member details
 */

/**
 * Added by - Ashlekh on 08-04-2025
 * Reason - To post Member details
 */
export const memberRegistrationDetailsAPI = async (memberData) => {
  try {
    const response = await API.post(`member_registration/`, memberData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (err) {
    console.error("Error in API:", err);
    return {};
  }
};
/**
 * End of code - Ashlekh on 08-04-2025
 * Reason - To post member details
 */

/**
 * Added by - Ashlekh on 24-04-2025
 * Reason - To get details of School page
 */
export const getSchoolDetailsAPI = async () => {
  const response = await API.get(`school/`).catch((err) => console.log(err));  
  if (response.response) {
    if (response.response.status === 500) {
      console.log(response.response.data);
    } else if (response.response.status === 404) {
      console.log(response.response.data);
    }
    return response ? response.data : {};
  } else {
    if (response.status === 200) {
      return response ? response.data : {};
    }
  }
};
/**
 * End of code - Ashlekh on 24-04-2025
 * Reason - To get details of School page
 */

/**
 * Added by - Ashlekh on 24-04-2025
 * Reason - To get details of member list
 */
export const getMemberDetailsListAPI = async (id) => {
  try {
    const response = await API.get(`member_details_list/`, {
      headers: {
        "Content-Type": "application/json",
      },
      params: {
        id: id,
      },
    }).catch((err) => console.log(err));

    if (response.response) {
      if (response.response.status === 500) {
        console.log(response.response.data);
      } else if (response.response.status === 404) {
        console.log(response.response.data);
      }
      return response ? response.data : {};
    } else {
      if (response.status === 200) {
        return response ? response.data : {};
      }
    }
  } catch (err) {
    console.error("Error fetching details:", err);
    return {};
  }
};
/**
 * End of code - Ashlekh on 24-04-2025
 * Reason - To get details of member list
 */